import React from "react";
import { ArrowRight, ShieldCheck, ScaleIcon } from "lucide-react";
import { LOGO_COLOR, CTA_HREF, FARO_IMAGE } from "./constants";

export const CierreCTA = () => (
    <section
        id="acceso"
        className="relative overflow-hidden py-20 sm:py-28"
        style={{
            backgroundImage: `linear-gradient(180deg, rgba(255,255,255,0.82) 0%, rgba(248,250,252,0.78) 55%, rgba(240,247,252,0.85) 100%), url('${FARO_IMAGE}')`,
            backgroundSize: "cover",
            backgroundPosition: "center 30%",
            backgroundRepeat: "no-repeat",
        }}
        data-testid="cierre-section"
    >
        <div
            aria-hidden="true"
            className="absolute inset-0 pointer-events-none opacity-[0.35]"
            style={{
                backgroundImage:
                    "radial-gradient(circle at 15% 20%, rgba(10,126,92,0.08) 0%, transparent 55%), radial-gradient(circle at 85% 80%, rgba(0,58,105,0.09) 0%, transparent 55%)",
            }}
        />
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <img
                src={LOGO_COLOR}
                alt="Lotería de Falcón"
                className="h-20 w-20 sm:h-24 sm:w-24 object-contain mx-auto mb-6"
                data-testid="cierre-logo"
            />

            <span
                className="text-xs font-semibold uppercase tracking-[0.22em]"
                style={{ color: "var(--lf-green-dark)" }}
                data-testid="cierre-eyebrow"
            >
                Acceso al sistema SILVEN
            </span>

            <h2
                className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold lf-text-blue leading-[1.1]"
                style={{
                    textShadow:
                        "0 2px 18px rgba(255,255,255,0.85), 0 1px 3px rgba(255,255,255,0.9)",
                }}
                data-testid="cierre-title"
            >
                Comienza tu trámite de forma digital
            </h2>

            <div className="flex justify-center mt-6">
                <div className="lf-gold-divider" />
            </div>

            <p
                className="mt-8 text-base sm:text-lg leading-relaxed lf-text-mute max-w-2xl mx-auto"
                style={{
                    textShadow: "0 1px 10px rgba(255,255,255,0.9)",
                }}
                data-testid="cierre-description"
            >
                Accede a nuestra plataforma SILVEN para la gestión de licencias,
                fiscalización y trámites oficiales de manera transparente y
                eficiente.
            </p>

            <div
                className="mt-10 flex justify-center"
                data-testid="cierre-cta-wrapper"
            >
                <a
                    href={CTA_HREF}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="lf-cta lf-cta-lg group"
                    data-testid="cierre-cta-button"
                >
                    <span className="lf-cta-shine" />
                    <span className="relative z-10">INGRESAR AL SISTEMA</span>
                    <ArrowRight
                        size={20}
                        strokeWidth={2.5}
                        className="relative z-10 transition-transform duration-300 group-hover:translate-x-1"
                    />
                </a>
            </div>

            <div
                className="mt-10 flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-xs sm:text-sm lf-text-mute"
                data-testid="cierre-trust-row"
            >
                <span className="inline-flex items-center gap-2">
                    <ShieldCheck
                        size={16}
                        style={{ color: "var(--lf-green-dark)" }}
                    />
                    Entorno oficial y seguro
                </span>
                <span className="inline-flex items-center gap-2">
                    <ScaleIcon
                        size={16}
                        style={{ color: "var(--lf-green-dark)" }}
                    />
                    Trámite 100% transparente
                </span>
            </div>
        </div>
    </section>
);
